import React from "react";
import { Box, Flexbox } from "codekit";

const CONF = {
  verde: {
    topBar: "#16A34A",
    valColor: "#16A34A",
    bg: "success-50",
    borderColor: "success-200",
    label: "Al día — menos de 15 días",
    desc: "DOs dentro del rango normal",
  },
  ambar: {
    topBar: "#D97706",
    valColor: "#D97706",
    bg: "warning-50",
    borderColor: "warning-200",
    label: "En alerta — 15 a 30 días",
    desc: "DOs que requieren seguimiento",
  },
  critico: {
    topBar: "#E8472A",
    valColor: "#E8472A",
    bg: "error-50",
    borderColor: "error-200",
    label: "Crítico — más de 30 días",
    desc: "DOs con vencimiento urgente",
  },
};

const KpiCard = ({ type, count }) => {
  const c = CONF[type];
  return (
    <Box
      border={1}
      rounded="lg"
      spacing={3}
      bg={c.bg}
      borderColor={c.borderColor}
      style={{ flex: 1, minWidth: 0, position: "relative", overflow: "hidden" }}
    >
      <Box
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: c.topBar,
          borderRadius: "1rem 1rem 0 0",
        }}
      />
      <Box mb={2} style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: ".06em", color: "#6B7280" }}>
        {c.label}
      </Box>
      <Box mb={1} style={{ fontSize: 36, fontWeight: 700, color: c.valColor, fontFamily: "monospace", lineHeight: 1 }}>
        {count}
      </Box>
      <Box style={{ fontSize: 11, color: "#6B7280" }}>{c.desc}</Box>
    </Box>
  );
};

/**
 * Fila de KPIs semafóricos del monitor de entrega urgente
 * @author Oscar Rosero <oscar.rosero@repremundo.com.co>
 * @since 2026-05-01
 * @param {{ verde: number, ambar: number, critico: number }} kpis
 */
const Kpicards = ({ kpis }) => (
  <Box mb={5}>
    <Flexbox gap={3}>
      <KpiCard type="verde" count={kpis.verde} />
      <KpiCard type="ambar" count={kpis.ambar} />
      <KpiCard type="critico" count={kpis.critico} />
    </Flexbox>
  </Box>
);

export default Kpicards;
